import { useSavedContentSync } from "@/hooks/use-saved-content-sync"

// init cross-tab sync for saved content (places and guides)
export function SavedContentSyncProvider() {
  useSavedContentSync()
  return null
}
